import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// @ts-ignore
const NakedTimeline = 'https://res.cloudinary.com/stamped/video/upload/v1608735226/Videos/nakedTimeline2_gbgcj3.mov';
// @ts-ignore
const NakedFinder = 'https://res.cloudinary.com/stamped/video/upload/v1608735219/Videos/nakedFinder2_h3go5b.mov';

export default function ToolsDemo() {
  const VideoArray = [NakedTimeline, NakedFinder];
  const [video, changeVideo] = useState(VideoArray[0]);

  const [active, setActive] = useState(0);

  function actionButtonClick(seq) {
    setActive(seq);
    changeVideo(VideoArray[seq]);
  }

  const ActionButton = ({ title, seq, disabled }) => (
    <div className="w-1/2 lg:w-auto lg:m-auto">
      {disabled ? (
        <button
          className={`opacity-25 text-sm mt-1 mb-1 lg:m-1 lg:w-auto pl-4 pr-4 pt-1 pb-1 font-semibold transition-all duration-300 border-2 border-black rounded-md hover:bg-black hover:text-white ${
            active === seq ? 'bg-black text-white' : ''
          }`}
        >
          {' '}
          {title}
        </button>
      ) : (
        <button
          onClick={() => actionButtonClick(seq)}
          className={`text-sm mt-1 mb-1 lg:m-1 lg:w-auto pl-4 pr-4 pt-1 pb-1 font-semibold transition-all duration-300 border-2 border-black rounded-md hover:bg-black hover:text-white ${
            active === seq ? 'bg-black text-white' : ''
          }`}
        >
          {' '}
          {title}
        </button>
      )}
    </div>
  );

  return (
    <>
      <div className="p-6 pb-24 mt-16 ml-6 mr-6 bg-white lg:m-auto lg:w-3/4 lg:p-12 font-brand">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-black font-brand lg:text-3xl">See our tools in action.</h1>
          {/* <p className="pt-5 m-auto lg:w-1/2">
            Our guide has detailed introductions and walkthroughs for everything. Save money and time. Get 10x the value.
          </p> */}

          <div id={'action-button-controller'} className="flex flex-wrap items-center mt-5 lg:w-3/4 lg:m-auto lg:mt-12 lg:flex-row lg:flex">
            <ActionButton seq={0} disabled={false} title="Timeline & Budget" />
            <ActionButton seq={1} disabled={false} title="College Finder" />
            {/* <ActionButton seq={2} disabled={true} title="Files and Folders" /> */}
            {/* <ActionButton seq={3} disabled={true} title="Chat Support" /> */}
          </div>
          <div id={'player'} className="relative">
            <AnimatePresence>
              <motion.video
                layoutId="videoFrame"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.8 }}
                loop
                key={video}
                muted
                autoPlay
                className="w-full m-auto mt-0 lg:w-2/5"
              >
                <source src={video} type="video/mp4" />
              </motion.video>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </>
  );
}
